import axios from 'axios';
import { push } from 'connected-react-router';

export const FETCH_CATALOGUE_REQUEST = 'FETCH_CATALOGUE_REQUEST';
export const FETCH_CATALOGUE_SUCCESS = 'FETCH_CATALOGUE_SUCCESS';
export const FETCH_CATALOGUE_FAILURE = 'FETCH_CATALOGUE_FAILURE';
export const FETCH_PRODUCT_REQUEST = 'FETCH_PRODUCT_REQUEST';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
export const FETCH_PRODUCT_FAILURE = 'FETCH_PRODUCT_FAILURE';
export const SEARCH_PRODUCTS_REQUEST = 'SEARCH_PRODUCTS_REQUEST';
export const SEARCH_PRODUCTS_SUCCESS = 'SEARCH_PRODUCTS_SUCCESS';
export const SEARCH_PRODUCTS_FAILURE = 'SEARCH_PRODUCTS_FAILURE';

function fetchCatalogueRequest() {
  return {
    type: FETCH_CATALOGUE_REQUEST
  }
}

function fetchCatalogueSuccess(products) {
  return {
    type: FETCH_CATALOGUE_SUCCESS,
    products
  }
}

function fetchCatalogueFailure() {
  return {
    type: FETCH_CATALOGUE_FAILURE
  }
}

function fetchProductRequest() {
  return {
    type: FETCH_PRODUCT_REQUEST
  }
}

function fetchProductSuccess(product) {
  return {
    type: FETCH_PRODUCT_SUCCESS,
    product
  }
}

function fetchProductFailure() {
  return {
    type: FETCH_PRODUCT_FAILURE
  }
}

function searchProductsRequest() {
  return {
    type: SEARCH_PRODUCTS_REQUEST
  }
}

function searchProductsSuccess(products) {
  return {
    type: SEARCH_PRODUCTS_SUCCESS,
    products
  }
}

function searchProductsFailure() {
  return {
    type: SEARCH_PRODUCTS_FAILURE
  }
}

export function fetchCatalogue(id, locale) {
  return dispatch => {
    dispatch(fetchCatalogueRequest());
    return axios.get(`/sites/${id}/products`, {params: {locale: locale}})
      .then(response => {
        dispatch(fetchCatalogueSuccess(response.data.products));
      }).catch(error => {
        dispatch(fetchCatalogueFailure());
      });
  }
}

export function fetchProduct(siteId, productSlug, locale) {
  return dispatch => {
    dispatch(fetchProductRequest());
    return axios.get(`/sites/${siteId}/products/${productSlug}`, {params: {locale}})
      .then(response => {
        dispatch(fetchProductSuccess(response.data.product));
      }).catch(error => {
        dispatch(fetchProductFailure());
        dispatch(push('/'));
      });
  }
}

export function searchProducts(siteId, searchParams, locale) {
  return dispatch => {
    dispatch(searchProductsRequest());
    return axios.post(`/sites/${siteId}/products/search`, {search: searchParams, locale: locale})
      .then(response => {
        dispatch(searchProductsSuccess(response.data.products));
      }).catch(error => {
        dispatch(searchProductsFailure());
      });
  }
}
